import {
  Lit3formBlock,
  html,
  classMap,
  unsafeHTML,
} from '@Root/lib/lit-3form-block';
import { styles } from './css';
import {
  analyticsCtaDataObject,
  analyticsLabelFromString,
  handleAdobeNavEvent,
} from '../../../helpers/adobe-analytics';

export class Sazh extends Lit3formBlock {
  static get characterName() {
    return 'sazh';
  }

  static get characterProperties() {
    return {
      content: { type: Object },
    };
  }

  static get characterStyles() {
    return [...styles];
  }

  render() {
    return html`
      <div class="block-wrapper">
        <div class="block-grid sazh-layout">
          <div class="header column">
            <h2>${unsafeHTML(this.headerStr)}</h2>
            <p class="description">${unsafeHTML(this.descriptionStr)}</p>
          </div>
          <div class="text-section column">
            <h4>${this.textSectionHeading}</h4>
            <div class="column-content">
              <ul>
                ${this.textSectionParagraphs.map(
                  paragraph => html`
                    <li>
                      ${this.renderRowContent(
                        paragraph.text || paragraph.content
                      )}
                    </li>
                  `
                )}
              </ul>
            </div>
          </div>
          ${this.downloadsList
            ? html`
                <div class="downloads column">
                  <h4>DOWNLOADS</h4>
                  <div class="column-content">
                    ${this.downloadsList.length > 0
                      ? this.downloadsList.map(download => {
                          return html`
                            <cta-button
                              cta-data=${this.downloadCtaData(download)}
                              cta-type="secondary"
                            ></cta-button>
                          `;
                        })
                      : html``}
                  </div>
                </div>
              `
            : html``}
          ${this.horizontalRule}
        </div>
      </div>
    `;
  }

  get headerStr() {
    return this.content.heading;
  }

  get descriptionStr() {
    return this.content.description;
  }

  get textSection() {
    return this.content.text_section || null;
  }

  get textSectionHeading() {
    return this.textSection?.heading || '';
  }

  get textSectionParagraphs() {
    return this.textSection?.paragraphs || [];
  }

  get downloadsList() {
    return this.content.download_links || [];
  }

  downloadCtaData(download) {
    download.fullWidth = true;
    download.target = '_blank';
    download.isDownload = true;
    download.placement = 'Downloads Column';
    return JSON.stringify(download);
  }

  renderRowContent(rowContent) {
    if (typeof rowContent !== 'object') return this.rowContentText(rowContent);

    if (Array.isArray(rowContent))
      return html`
        ${rowContent.map(this.rowContentLink.bind(this))}
      `;

    return html`
      ${this.rowContentLink(rowContent)}
    `;
  }

  rowContentLink(link) {
    return !!link && typeof link === 'object'
      ? html`
          <a
            href=${link.url || ''}
            @click="${event => this.handleRowLinkClick(link, event)}"
          >
            ${this.rowContentText(link.text || '')}
          </a>
        `
      : html``;
  }

  handleRowLinkClick(link, event) {
    if (!link.url) return;
    handleAdobeNavEvent({
      navString: `NAV|${analyticsLabelFromString(
        this.headerStr || 'Sazh'
      )}|${analyticsLabelFromString(link.text || link.url)}`,
      destinationUrl: link.url,
      event,
    });
  }

  rowContentText(text) {
    text = text || '';
    // remove any empty <p> tags coming from the CMS editor
    text = text.replaceAll('<p><br /></p>', '');
    return html`
      <p class="row-content-text">
        ${unsafeHTML(text)}
      </p>
    `;
  }
}
Sazh.defineElement();
